<template>
  <div class="ima-sign-status">
    <button v-for="item in status.data" :key="item.id" :disabled="!canSetSpecificSignStatus(item) || sign.data.status.id === item.id" :class="{ 'active': isActive(item), 'done' : isDone(item)}" @click="onStatusChange(item)">
      <span class="ima-sign-status__circle">
        <b-icon icon="check" size="medium" />
      </span>
      <span class="ima-sign-status__label">
        <span>{{item.name}}</span>
      </span>
    </button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { updateStatus } from '@/store/modules/sign'
import { canSetSpecificSignStatus } from '@/services/permissions'

export default {
  name: 'ima-sign-status',
  computed: {
    ...mapState(['status', 'sign'])
  },
  methods: {
    ...mapActions([updateStatus]),
    onStatusChange (status) {
      this.updateStatus({ sign: this.sign.data, status })
    },
    isDone (item) {
      const index = this.status.data.findIndex(({ id }) => id === item.id)
      const currentIndex = this.status.data.findIndex(
        ({ id }) => id === this.sign.data.status.id
      )
      return index < currentIndex || index === currentIndex
    },
    isActive (status) {
      return status.id === this.sign.data.status.id
    },
    canSetSpecificSignStatus (status) {
      return canSetSpecificSignStatus(status)
    }
  }
}
</script>

<style lang="scss">
@import '../scss/settings';

.ima-sign-status {
  display: flex;
  flex-direction: column;
  list-style: none;

  button {
    appearance: none;
    background-color: transparent;
    border: none;
    align-items: center;
    display: inline-flex;
    margin-bottom: 0.2rem;
    width: fit-content;

    &.active,
    &.active:disabled,
    &.done {
      opacity: 1;
    }

    &:not(.active) {
      i {
        opacity: 0;
      }
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.3;
    }

    &:hover:not(:disabled) {
      cursor: pointer;
      opacity: 1;
    }

    &:focus {
      outline: none;
    }

    @for $i from 1 through length($signStatus) {
      &:nth-child(#{$i}) {
        color: nth($signStatus, $i);
      }
    }

    .ima-sign-status__circle {
      border-radius: 50%;
      background-color: currentColor;
      display: inline-block;
      padding: 0.3rem 0.3rem;
      position: relative;
      text-align: center;

      i {
        color: #000;
        position: relative;
        z-index: 1;
        font-weight: 800;
      }
    }

    &:hover:not(:disabled),
    &.active {
      .ima-sign-status__circle {
        &::before {
          content: '';
          display: block;
          background: #ffffff;
          width: 100%;
          height: 100%;
          z-index: 1;
          position: absolute;
          top: 0;
          left: 0;
          border-radius: 50%;
          transform: scale(0.8);
        }
      }
    }

    .ima-sign-status__label {
      background-color: currentColor;
      margin-left: 0.3rem;
      padding: 0.2rem 0.3rem;
      span {
        font-size: 1rem;
        color: #fff;
        text-transform: uppercase;
        user-select: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SignStatus.vue